import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=75aad224&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=75aad224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aad224",
  null
  
)

export default component.exports